import { useQuery, WatchQueryFetchPolicy } from '@apollo/client';
import { READ_CITY_PMCS_BY_MEMBERGROUP } from 'graphql/queries/readCityPMCByMemberGroup';
import { useCityParkingStore } from 'stores/cityParkingStore';
import {
  Pmc,
  Query,
  QueryReadCityPmcsByMemberGroupArgs,
} from 'types/generatedSchemaTypes';

const useCityPmcsByMembergroup = (
  fetchPolicy: WatchQueryFetchPolicy = 'cache-first'
) => {
  const { memberGroupName, countryCode } = useCityParkingStore(
    (state) => state.byMemberGroupSearchParams
  );
  const { data, loading, error } = useQuery<
    Query,
    QueryReadCityPmcsByMemberGroupArgs
  >(READ_CITY_PMCS_BY_MEMBERGROUP, {
    fetchPolicy,
    errorPolicy: 'all',
    variables: {
      input: {
        memberGroupName,
        countryCode,
      },
    },
  });
  return {
    cityPmcs: (data?.readCityPmcsByMemberGroup?.content ?? []) as Pmc[],
    loading,
    error,
  };
};

export default useCityPmcsByMembergroup;
